import classNames from 'classnames'
import { useTranslation } from 'next-i18next/pages'
import styles from './EncyclopediaCategory.module.scss'
import SubCategoryCard from 'components/encyclopedia/sub-category-card/SubCategoryCard'
import ArticleSection from 'components/article/article-section/ArticleSection'
import Hero from 'features/encyclopedia/components/hero/Hero'
import EncyclopediaNav from 'features/encyclopedia/components/encyclopedia-nav/EncyclopediaNav'
import FeaturedArticle from 'components/article/featured-article/FeaturedArticle'
import { Heading } from '@boltenergy-be/design-system'
import { EncyclopediaCategoryProps } from './types'

const EncyclopediaCategory = ({ category, popularArticles, highlightedArticle, subCategories }: EncyclopediaCategoryProps) => {
  // i18n
  const { t } = useTranslation(['encyclopedia'])

  return (
    <main>
      {/* BREADCRUMBS + SEARCH */}
      <EncyclopediaNav />

      {/* HERO */}
      <Hero category={category} />

      {/* TOPICS */}
      {!!subCategories?.length && (
        <section className={classNames('container', styles['sub-categories'])}>
          <Heading as="h2" variant="h3">
            {t('subCategories', 'Topics')}
          </Heading>
          <div className={styles['categories-grid']}>
            {subCategories?.map((subCategory, idx) => (
              <SubCategoryCard subCategory={subCategory} key={`${subCategory.slug}-${idx}`} color={category.color} />
            ))}
          </div>
        </section>
      )}

      {/* HIGHLIGHTED */}
      {highlightedArticle && <FeaturedArticle article={highlightedArticle} />}

      {/* ARTICLES */}
      <ArticleSection articles={popularArticles} className={styles.articles} title={t('articles', 'Artikels')} />
    </main>
  )
}

export default EncyclopediaCategory
